"use client";

import { useState, useEffect } from 'react';
import { FormattedMessage } from "react-intl";
import Cookies from "js-cookie";
import { useSession } from "next-auth/react";

import { initClarity } from "@/helpers/Clarity";
import { initGoogleTag } from "@/helpers/GoogleTag";

const ConsentDialog = () => {
  const { data: session } = useSession();
  const currentUser = session?.user || null;

  const [showDialog, setShowDialog] = useState(false);

  const handleAccept = () => {
    Cookies.set("clarityConsent", true, {
      expires: 365,
      domain: ".downfor.life"
    });
    initClarity();
    initGoogleTag();
    setShowDialog(false);
  };

  const handleDecline = () => {
    Cookies.set("clarityConsent", false, {
      expires: 365,
      domain: ".downfor.life"
    });
    setShowDialog(false);
  };

  useEffect(() => {
    const consentGiven = Cookies.get("clarityConsent");

    if (!consentGiven && !currentUser) {
      setShowDialog(true);
    } else if (consentGiven === "true" || !!currentUser) {
      initClarity();
      initGoogleTag();
    }
  }, [currentUser]);

  return (
    showDialog && (
      <div className="consent-dialog">
        <div className="consent-content">
          <h2>
            <FormattedMessage id="consent-dialog-title" />
          </h2>
          <p>
            <FormattedMessage id="consent-dialog-description" />
          </p>
          <div className="consent-button-group">
            <button className="consent-decline-btn" onClick={handleDecline}>
              <FormattedMessage id="consent-dialog-decline-button" />
            </button>
            <button className="consent-accept-btn" onClick={handleAccept}>
              <FormattedMessage id="consent-dialog-accept-button" />
            </button>
          </div>
        </div>
      </div>
    )
  );
};

export default ConsentDialog;
